import { useEffect } from 'react';
import { Box, useMediaQuery } from '@mui/material';
import i18n from '../../common/i18n';
import HeaderTags from '../../common/HeaderTags';
import Hero from './components/Hero';
import QuienesSomos from './components/QuienesSomos';
import Productos from './components/Productos';
import Requisitos from './components/Requisitos';
import AppSection from './components/AppSection';
import AyudaHome from './components/AyudaHome';
import Contacto from './components/Contacto';
import { loadWebchat, deleteWebChat } from '../../webchatComponentScript';
import { homeColors } from './style/homeStyles';

// Rediseño de la Home: cada sección resuelve su layout con isMobile y centra
// su contenido en HOME_MAX_WIDTH.
const HomePage = () => {
  const matchesMobile = useMediaQuery('(max-width: 1201px)');

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
    loadWebchat();
    return () => deleteWebChat();
  }, []);

  // El fondo blanco del rediseño aplica solo a desktop; mobile conserva el fondo original.
  return (
    <Box sx={{ backgroundColor: matchesMobile ? homeColors.bg : homeColors.white }}>
      <HeaderTags title={i18n.metaTitleHome} content={i18n.metaDescriptionHome} scriptMarkUpSchema />

      <Hero isMobile={matchesMobile} />
      <QuienesSomos isMobile={matchesMobile} />
      <Productos isMobile={matchesMobile} />
      <Requisitos isMobile={matchesMobile} />
      <AppSection isMobile={matchesMobile} />
      <AyudaHome isMobile={matchesMobile} />
      <Contacto isMobile={matchesMobile} />
    </Box>
  );
};

export default HomePage;
